import { Spacing } from '@persona-id/design-tokens';
import { DateTime } from 'luxon';
import { Link } from 'react-router-dom-v5-compat';
import styled from 'styled-components';

import { ReportRun } from 'dashboard/models/report-run';
import { paragraphMixins } from 'design-system/mixins/text';
import { SHORT_FORM_DATE } from 'lib/constants/luxonFormats';
import { ApiModel } from 'lib/interfaces/api';

const ModuleHeaderContainer = styled('div')`
  display: grid;
`;

const TitleContainer = styled('div')`
  display: flex;
  align-items: center;
`;

const Title = styled('span')`
  margin-right: ${Spacing[2]};
`;

const SubTitle = styled('div')`
  ${paragraphMixins.md}

  color: ${({ theme }) => theme.color.text.tertiary};
  height: ${({ theme }) => theme.lineHeightSmall};
`;

const getTitleName = (reportRunType: ReportRun['type']) => {
  switch (reportRunType) {
    case ApiModel.ReportRunCustomList:
      return 'Custom List Report Run';
    default:
      return 'Report Run';
  }
};

interface ReportRunModuleHeaderProps {
  reportRun: ReportRun;
}

const ReportRunModuleHeader = ({ reportRun }: ReportRunModuleHeaderProps) => {
  const completedAt = DateTime.fromISO(reportRun.attributes['completed-at']).toFormat(
    SHORT_FORM_DATE,
  );
  return (
    <ModuleHeaderContainer>
      <TitleContainer>
        <Title>{getTitleName(reportRun.type)}</Title>
      </TitleContainer>
      <SubTitle>
        <Link
          to={`/dashboard/reports/${reportRun.relationships.report.data.id}/runs/${reportRun.id}`}
        >
          {`${reportRun.attributes['primary-input'] || ''} - Report Run on ${completedAt}`}
        </Link>
      </SubTitle>
    </ModuleHeaderContainer>
  );
};

export default ReportRunModuleHeader;
